import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Levels = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={color || 'none'}
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke || 'currentColor'}
      {...props}
    >
      <path
        d="M12.5 3V13M9.5 5V13M6.5 7V13M3.5 9V13"
        stroke={stroke || 'currentColor'}
      />
    </svg>
  ),
)
Levels.displayName = 'Levels'

export default Levels
